import { clearAuthSessionStorage } from "./sessionTermination";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "./tokenKeys";

export const logout = (navigate: any) => {
  clearAuthSessionStorage();
  navigate("/login");
};

export const isLoggedIn = (isLogged?: boolean) => {
  const hasTokens =
    !!sessionStorage.getItem(ACCESS_TOKEN_KEY) ||
    !!sessionStorage.getItem(REFRESH_TOKEN_KEY);
  return hasTokens || isLogged === true;
};
